import PostsAdapter from './base';

export default class PagePermission extends PostsAdapter {
  modelNamePlural = 'pagePermissions';
}
